'use strict';

// import 'whatwg-fetch';
// import './lib/polyfills';

import './lib/buttons';
import './lib/nav';

// import './lib/animatedLogo';
import ScrollReveal from './lib/scrollReveal';
import {creator} from './lib/utilities';

window.reveal = creator('[animate-up]', ScrollReveal);

// gooey effect for headings
// const gooeyWidth = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gooey-width'));
// const gooeyHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gooey-height'));
//
// const $gooContainers = document.querySelectorAll('.type-display:not(.is-goo-hidden)');
//
// $gooContainers.forEach(($gooContainer) => {
//   $gooContainer.addEventListener('mousemove', (e) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const left = e.clientX - rect.left - (gooeyWidth / 2) + 'px';
//     const top = e.clientY - rect.top - (gooeyHeight / 2) + 'px';
//     document.documentElement.style.setProperty('--gooey-x', left);
//     document.documentElement.style.setProperty('--gooey-y', top);
//   });
// });
